import React from 'react';

import './TechDivider.scss';

export const TechDivider = () => {
	return (
		<li className="tech-divider">
			<h2>Pre Tech Experience</h2>
		</li>
	);
};
